import * as React from 'react';
import { useSelector } from 'react-redux';

import { EmptyPageContainer } from '../EmptyPage';
import { selectIds } from '../../selectors/ids';
import { Main } from '../../components/Main';
import { TableContainer } from '../Table';
import { selectIsDesktop } from '../../selectors/page';
import { MobilePageContainer } from '../MobilePage';
import { PageTitleContainer } from '../PageTitle';
import { ControlsContainer } from '../Controls';
import { PageLoaderContainer } from '../PageLoader';

export const PageContainer: React.VFC = () => {
  const ids = useSelector(selectIds);
  const idsAvailable = ids.length > 0;
  const isDesktop = useSelector(selectIsDesktop);

  if (isDesktop) {
    if (!idsAvailable) {
      return <EmptyPageContainer />;
    } else {
      return (
        <Main>
          <PageTitleContainer />
          <ControlsContainer />
          <TableContainer />
          <PageLoaderContainer />
        </Main>
      );
    }
  } else {
    return <MobilePageContainer />;
  }
};
